<template>
	<div class="promo-banner" :class="{ empty: !game.promotionBarImage }">
		<div
			v-if="game.promotionBarImage"
			class="banner"
			:class="{ clickable: game.promotionBarLink }"
			:style="{ backgroundImage: `url(${cdnHost}${getLocaleString(game.promotionBarImage)})` }"
			@click="promoClick"
		></div>
	</div>
</template>

<script>
import { getLocaleString } from '../../plugins/helpers';

export default {
	name: 'GameDetailsPromoBanner',
	components: {},
	props: {
		game: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {};
	},
	computed: {
		language() {
			return this.$i18n.locale;
		},
	},
	mounted() {},
	methods: {
		promoClick() {
			if (!this.game.promotionBarLink) return;
			dataLayer.push({
				event: 'Game Detail Promotion Head Banner Click',
				gameDetailName: this.game.name,
				gameDetailID: this.game.productID,
			});
			window.open(this.getLocaleString(this.game.promotionBarLink), '_blank');
		},
		getLocaleString(data) {
			return getLocaleString(data, this.language);
		},
	},
};
</script>

<style lang="less" scoped>
.promo-banner {
	background-color: #1f2023;
	height: 210px;
	padding-top: 50px;
	width: 100%;
	&.empty {
		height: 40px;
		margin: 0;
		padding: 0;
	}
	.banner {
		background-position: center;
		background-size: cover;
		height: 120px;
		width: 100%;
		&.clickable {
			cursor: pointer;
		}
	}
}

@media (min-width: 768px) {
	.promo-banner {
		height: 230px;
		padding-top: 70px;
	}
}

@media (min-width: 1024px) {
	.promo-banner {
		background-color: #191a1c;
		height: 134px;
		padding-top: 40px;
		.banner {
			height: 64px;
			margin: auto;
			width: 770px;
		}
	}
}

@media (min-width: 1280px) {
	.promo-banner {
		height: 170px;
		padding-top: 50px;
		&.empty {
			height: 50px;
		}
		.banner {
			height: 80px;
			width: 960px;
		}
	}
}

@media (min-width: 1440px) {
	.promo-banner {
		height: 160px;
		padding-top: 40px;
		&.empty {
			height: 70px;
		}
		.banner {
			height: 90px;
			width: 1080px;
		}
	}
}

@media (min-width: 1600px) {
	.promo-banner {
		height: 180px;
		.banner {
			height: 100px;
			width: 1200px;
		}
	}
}

@media (min-width: 1920px) {
	.promo-banner {
		height: 200px;
		.banner {
			height: 120px;
			width: 1440px;
		}
	}
}
</style>
